const API_KEY = process.env.REACT_APP_API_KEY

const API_URL = `https://www.omdbapi.com/?apikey=${API_KEY}`

export {
    API_URL
}